<template>
    <v-dialog v-model="$store.state.tracking.TrackingDiff" width="1200px" transition="dialog-transition">
        <v-card>
            <v-toolbar color="primary" dense>
                <v-spacer></v-spacer>
                <v-toolbar-title class="white--text">Tracking Demurrage Diff</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="$store.state.tracking.TrackingDiff = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-container grid-list-xs fluid v-if="!spinner">
                <v-simple-table fixed-header height="700px" dense >
                    <tbody v-for="(item,idx) in data.shift_details" v-bind:key="idx">
                        
                        <tr v-show="item.orders.length > 0">
                            <th class="text-center" style="border-right: 1px solid #000;">{{ item.driver.Name }}</th>
                            <th class="text-center" colspan="3" style="border-right: 1px solid #000;">Terminal</th>
                            <th class="text-center" colspan="3">Station</th>
                        </tr>
                        <tr v-show="item.orders.length > 0">
                            <th class="text-center" style="border-right: 1px solid #000;">OrderID</th>
                            <th class="text-center">TStart</th>
                            <th class="text-center">TEnd</th>
                            <th class="text-center" style="border-right: 1px solid #000;">TDiff</th>
                            <th class="text-center">StStart</th>
                            <th class="text-center">StEnd</th>
                            <th class="text-center">StDiff</th>
                        </tr>
                        <template v-for="(itm,i) in item.orders">
                            <tr v-bind:key="i" class="text-center">
                                <td>{{ itm.OrderID }}</td>
                                <td>{{ itm.TStart }}</td>
                                <td>{{ itm.TEnd }}</td>
                                <td v-if="itm.TDiff > 75" style="color: red;">{{ itm.TDiff }}</td>
                                <td v-else>{{ itm.TDiff }}</td>
                                <td>{{ itm.StStart }}</td>
                                <td>{{ itm.StEnd }}</td>
                                <td v-if="itm.StDiff > 75" style="color: red;">{{ itm.StDiff }}</td>
                                <td v-else>{{ itm.StDiff }}</td>
                            </tr>
                            <tr v-bind:key="i+'descrip'">
                                <td>GPSComments</td>
                                <td colspan="6">{{ itm.GPSComments }}</td>
                            </tr>
                        </template>
                    </tbody>
                </v-simple-table>
            </v-container>
            <v-container grid-list-xs  v-else>
                <div class="spinner mb-5">
                                <div class="sk-chase">
                                    <div class="sk-chase-dot"></div>
                                    <div class="sk-chase-dot"></div>
                                    <div class="sk-chase-dot"></div>
                                    <div class="sk-chase-dot"></div>
                                    <div class="sk-chase-dot"></div>
                                    <div class="sk-chase-dot"></div>
                                </div>
                            </div>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
export default {
    props: ['ShiftId'],
    data: function() {
        return {
            data: [],
            spinner:true,
        };
    },
    async mounted() {
        this.loadOrderCK(this.ShiftId);
    },
    methods: {
        loadOrderCK: function(ShiftId) {
            var str = this.$store;
            console.log(ShiftId);
            axios
                .get('orders/diff/report/' + this.ShiftId, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data[0], ShiftId);
                    this.data = response.data[0];
                    this.spinner = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
         }
    }
};
</script>
<style scoped>
    td { padding: 5px !important;} 
    .R1 {
        background: #0b2161 !important;
    }
    .R1R {
        background: #0b2161 !important;
        color: #f5f6ce !important;
        font-size: small !important;
        text-align: right !important;
    }
    .R1RT {
        background: #0b2161 !important;
        color: #f5f6ce !important;
        font-size: small !important;
        text-align: right !important;
    }
    .R1RD {
        background: #ffffff !important;
        color: #0b2161 !important;
        font-size: small !important;
        text-align: left !important;
    }
    .R2 {
        background: #0174df !important;
        color: #f2f5a9 !important;
        font-size: small !important;
    }
    .R3 {
        background: #e6e6e6 !important;
        color: #000000 !important;
        font-size: small !important;
    }
    .R4 {
        background: #e0e6f8 !important;
        color: #000000 !important;
        font-size: small !important;
    }
</style>
<style>
.spinner {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 50px;
}

.sk-chase {
    width: 40px;
    height: 40px;
    position: relative;
    animation: sk-chase 2.5s infinite linear both;
}

.sk-chase-dot {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    animation: sk-chase-dot 2s infinite ease-in-out both;
}

.sk-chase-dot:before {
    content: '';
    display: block;
    width: 25%;
    height: 25%;
    background-color: #4f83cc;
    border-radius: 100%;
    animation: sk-chase-dot-before 2s infinite ease-in-out both;
}

.sk-chase-dot:nth-child(1) {
    animation-delay: -1.1s;
}
.sk-chase-dot:nth-child(2) {
    animation-delay: -1s;
}
.sk-chase-dot:nth-child(3) {
    animation-delay: -0.9s;
}
.sk-chase-dot:nth-child(4) {
    animation-delay: -0.8s;
}
.sk-chase-dot:nth-child(5) {
    animation-delay: -0.7s;
}
.sk-chase-dot:nth-child(6) {
    animation-delay: -0.6s;
}
.sk-chase-dot:nth-child(1):before {
    animation-delay: -1.1s;
}
.sk-chase-dot:nth-child(2):before {
    animation-delay: -1s;
}
.sk-chase-dot:nth-child(3):before {
    animation-delay: -0.9s;
}
.sk-chase-dot:nth-child(4):before {
    animation-delay: -0.8s;
}
.sk-chase-dot:nth-child(5):before {
    animation-delay: -0.7s;
}
.sk-chase-dot:nth-child(6):before {
    animation-delay: -0.6s;
}
</style>